// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  name: __t.string(),
  ruleset: __t.string(),
  visibility: __t.string(),
  allocation: __t.string(),
  maxArmiesPerPlayer: __t.u32(),
  theatreJson: __t.string(),
  factionsJson: __t.string(),
  rulesJson: __t.string(),
};
